import React from "react";
import PropTypes from "prop-types";

const LinkTargetBlank = ({href, children}) => (
  <a
    data-testid={"LinkTargetBlank-Link"}
    href={href}
    rel="noreferrer noopener"
    target="_blank">
    {children}
  </a>
);

LinkTargetBlank.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.array.isRequired
};

export default LinkTargetBlank;
